import { authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

export function postAgent13(params) {
  return authPost(`${baseUrl}/Agent13.ashx`, params);
}

export function postAgent14(params) {
  return authPost(`${baseUrl}/Agent14.ashx`, params);
}
